import { createPromise } from "common/promises/create";
import * as PIXI from "pixi.js";
import { toPath } from "../resource";
export const sprite = {
    loadTexture,
    fromTexture,
};
async function loadTexture(imageName) {
    const texture = PIXI.Texture.from(toPath(imageName));
    const { promise, resolve } = await createPromise();
    console.log(`Load ${imageName}`);
    texture.baseTexture.once("loaded", () => resolve(texture));
    if (texture.valid) {
        console.log(`Already loaded ${imageName}`);
        return texture;
    }
    await promise;
    console.log(`Loaded  ${imageName}`);
    return texture;
}
function fromTexture(texture) {
    const sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5, 0.5);
    return sprite;
}
//# sourceMappingURL=sprite.js.map